import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import {
  BuildIcon,
  DesignIcon,
  LaunchIcon,
  MaintenanceIcon,
  PlaneIcon,
  TestIcon,
} from "../../../app-constants";
const WorkFlow = [
  {
    logo: PlaneIcon,
    title: "Thorough Assessment",
    description:
      "Conduct a meticulous evaluation of your intellectual property landscape, laying the foundation for a tailored protection strategy.",
    count: "01",
  },
  {
    logo: DesignIcon,
    title: "Customized Protection Plans",
    description:
      " Transform ideas into perceptible designs, warranting smooth user experiences.",
    count: "02",
  },
  {
    logo: BuildIcon,
    title: "Global Registration",
    description:
      "Navigate the complex international intellectual property laws, managing the registration process efficiently to secure your rights in multiple jurisdictions.",
    count: "03",
  },
  {
    logo: TestIcon,
    title: "Regular Monitoring and Updates",
    description:
      "Implement continuous monitoring mechanisms to stay ahead of potential threats, along with regular updates to adapt to evolving market conditions.",
    count: "04",
  },
  {
    logo: LaunchIcon,
    title: "Enforcement Strategies",
    description:
      "Formulate proactive enforcement strategies to caution breach and take swift action against any unauthorized use of your intellectual property.",
    count: "05",
  },
  {
    logo: MaintenanceIcon,
    title: "Strategic Collaboration",
    description:
      "Collaborate strategically with legal experts and professionals, ensuring seamless execution of protection strategies with ongoing guidance.",
    count: "06",
  },
];
const Workflow = () => {
  return (
    <div className="workflow p-100 tekrevol_gray_bg">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Our IP Protection <span>Process</span>
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <p>
              At TekRevol, we've streamlined our Intellectual Property
              protection process to deliver maximum value for your business. Our
              approach is designed to provide comprehensive coverage and ensure
              the security of your valuable assets throughout the journey.
              Here's an overview of our IP protection process:
            </p>
          </Col>
        </Row>
        <Row className="workflow_secion">
          {WorkFlow.map((item, index) => (
            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="my-auto">
              <div className="workflow_items">
                <div className="item_name">
                  <span>{item.count}</span>
                  {item.title}
                  <div className="item_icon"> {item.logo}</div>
                </div>
                <p>{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Workflow;
